module.exports = __webpack_public_path__ + "img/Email.3961345f.svg";